module.exports = __webpack_public_path__ + "static/media/shoaibCV.720a0918.pdf";